import axios from 'axios';
import { API_URL } from "../utils/ApiLinks";
import { CreateCouponsForSeveralPropertiesDto, UpdatePropertyCouponDTO } from '../types/PropertyCoupon';
import { CreatePropertyCouponDTO } from '../types/PropertyCoupon';

export class PropertyCouponService {
    private baseUrl: string = API_URL;
    

    async updateCoupon(id: string, dto: UpdatePropertyCouponDTO): Promise<boolean> {
        try {
            const response = await axios.put(`${this.baseUrl}/PropertyCoupon/${id}`, dto);
            return response.data.success;
        } catch (error) {
            console.error('Error updating coupon:', error);
            return false;
        }
    }

    async deleteCoupon(id: string): Promise<boolean> {
        try {
            const response = await axios.delete(`${this.baseUrl}/PropertyCoupon/${id}`);
            return response.data.success;
        } catch (error) {
            console.error('Error deleting coupon:', error);
            return false;
        }
    }

    async getCoupon(id: string): Promise<any> {
        try {
            const response = await axios.get(`${this.baseUrl}/PropertyCoupon/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting coupon:', error);
            return null;
        }
    }

   async getByPropertyId(propertyId: number): Promise<any> {
        try {
            const response = await axios.get(`${this.baseUrl}/PropertyCoupon/by-property/${propertyId}`);
            return response.data;
        } catch (error) {
            return null;
        }
    }

    async createCoupon(dto: CreatePropertyCouponDTO): Promise<boolean> {
        try {
            const response = await axios.post(`${this.baseUrl}/PropertyCoupon`, dto);
            return response.data.success;
        } catch (error) {
            console.error('Error creating coupon:', error);
            return false;
        }
    }

    async createCouponsForSeveralProperties(dto: CreateCouponsForSeveralPropertiesDto): Promise<boolean> {
        try {
            const response = await axios.post(`${this.baseUrl}/PropertyCoupon/create-for-several-properties`, dto);
            return response.data.success;
        } catch (error) {
            console.error('Error creating coupons for several properties:', error);
            return false;
        }
    }
}